module.exports = __webpack_public_path__ + "img/colour-berry.0f7b21f2.png";